<template>
    <main-layout>
        <div style="padding-top:15px">
            <div class="headerSty"  @click="$router.push({path: '/RouteList'})">
                <img src='@/assets/button/back_button.png'>
                <span class="F1-R-19 span">ルートリストに戻る</span>
            </div>
            <span class="F3-M-27" style="cursor:pointer">
                ルート詳細
            </span>
        </div>
        <div class='body'>
            <div class='main'>
                <div class='main-left'>
                    <div class='placeTitle bgc1'>
                        <span class='placeTitle-font F2-M-20 overflow-fix' style="text-align:left;width:98%">
                          <img src="../../assets/icon/transport_kind0.png" style="margin-right: 0; height: 32px;width:32px;" v-if="routeInfo.transportKind=='0'">
                          <img src="../../assets/icon/transport_kind1.png" style="margin-right: 0; height: 32px;width:32px;" v-if="routeInfo.transportKind=='1'">
                          <img src="../../assets/icon/app_use.png" style="margin-right: 2px; height: 32px;width:32px;" v-if="routeInfo.routeType=='1'">
                          <img src="../../assets/icon/app_dontuse.png" style="margin-right: 2px; height: 32px;width:32px;" v-if="routeInfo.routeType!='1'">
                          {{ routeInfo.routeName}}
                        </span>
                    </div>
                    <div class='placeDistance'>
                        <div>ルートID : {{ routeInfo.displayRouteId }}</div>
                        <div>ルート距離 : {{ routeInfo.routeDistance | distanceFormatter }}</div>
                        <div>所要時間 {{ routeInfo.routeTotalTime | timeFormatter }}</div>
                    </div>

                    <div class='placeInfo slider'>
                        <!-- a标签 href 弹出框 -->
                        <div class='placeInfo-children bgc5h' v-for='(item, i) in routerInfo' :key='i' @click="detailed(item)" style='cursor:pointer' href="#modal-container-staySave" data-toggle="modal">
                            <!-- 圆圈 -->
                            <div class='radioClass' :class="[(i === 0 || i === routerInfo.length -1) && item.officeFlag === 1 ?'radioOffice':'']">
                                <!-- 圆圈里面的标记 -->
                                <template v-if='i === 0'>
                                    <div class='tagClass'>
                                        S
                                    </div>
                                </template>
                                <template v-if='i && i !== 0 && i !== routerInfo.length -1'>
                                    <div class='tagClass'>
                                        {{ item.font }}
                                    </div>
                                </template>
                                <template v-if='i === routerInfo.length -1'>
                                    <div class='tagClass'>
                                        G
                                    </div>
                                </template>
                            </div>
                            <!-- 竖线 -->
                            <!-- 第一个竖线 -->
                            <template v-if='i === 0'>
                                <div class='lineClassEnd'></div>
                            </template>
                            <!-- 正常常规竖线 -->
                            <template v-if='i && i !== 0 && i !== routerInfo.length -1'>
                                <div class='lineClass'></div>
                            </template>
                            <!-- 最后一个竖线 -->
                            <template v-if='i === routerInfo.length -1'>
                                <div class='lineClassFirst'></div>
                            </template>

                            <div class='placeInfo-children-body'>
                                <div class='front' >
                                    <img src="../../assets/icon/office_flag1.png" style="margin:2px 4px 0 0; height: 32px;width:32px;" v-if="item.officeFlag=='1'">
                                    <div style="margin:2px 4px 0 0; height: 32px;width:32px;" v-else></div>
                                    <span class='overflow-fix' style="text-align:left;width:98%">{{ item.stationName }}</span>
                                </div>
                                <div class='front'>
                                    <span style='font-size: 1.1em;font-weight: 500;'>{{ item.address }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 右侧地图 -->
                <div class='main-right'>
                    <google-map ref='gMap' :center-point='centerPoint' :map-id='mapId' :point-list='pointDataList'></google-map>
                </div>
            </div>
        </div>
        <!-- 脚部按钮 -->
        <div class='body-foot'>
            <button class="window-button" style='cursor:pointer' @click.stop='edit()'>
                <span class="F2-M-24">編集</span>
            </button>
            <button class="window-button" style='cursor:pointer' @click="deleteRouter(routeInfo.routeId)">
                <span class="F2-M-24">このルートを削除</span>
            </button>
            <!-- 区域外のときは表示しない -->
            <button class="window-button" style='cursor:pointer' @click="routeLogin()" v-if="routeInfo.transportKind == 0">
                <span class="F2-M-24">このルートで便を登録</span>
            </button>
        </div>
        <v-dialog v-show="showDialogRouter" :dialog-option="dialogOptionRouter" ref="dialogRouter"></v-dialog>
        <station-detailed-confirm ref="saveWindowDiv" :flag="flag"></station-detailed-confirm>
    </main-layout>
</template>

<script>
import MainLayout from '../layouts/mainLayout'
import googleMap from '@/components/googleMap'
import StationDetailedConfirm from '@/components/StationDetailedConfirm'
import STATION_ICON from '@/assets/map_icon/map_stop_point1.png'
import STATION_ICON_FIRST from '@/assets/map_icon/map_transit_point1.png'
import RouterDetails from '@/components/RouterDetails'
import dialog from '@/components/Dialog'
export default {
  components: {
    MainLayout,
    googleMap,
    StationDetailedConfirm,
    RouterDetails,
    'v-dialog': dialog
  },
  data () {
    return {
      mapId: 'routerId',
      stationDetailMapId: 'stationDetailMapId',
      centerPoint: {
        lat: 35.661041,
        lng: 139.87307
      },
      centerPoints: {
        lat: 35.661041,
        lng: 139.87307
      },
      //   弹出框
      showDialogRouter: false,
      dialogOptionRouter: {
        showNo: true,
        text: '',
        cancelButtonText: 'いいえ',
        confirmButtonText: 'はい'
      },
      // 路列表
      routerInfo: [],
      // 传给下个面页面信息
      routerInfos: [],
      viewModel: {},
      // 路的具体信息
      routeInfo: {},
      pointList: [],
      // 地图标记点集合包含图标
      pointDataList: [],
      flag: null
    }
  },
  async mounted () {
    this.loadData()
    // this.initMap()
  },
  methods: {
    // 获取数据
    loadData () {
      // 当前路对象
      let routeInfo = this.routeInfo = JSON.parse(sessionStorage.getItem('clickRoute')) || {}
      let routeId = routeInfo.routeId
      if (routeId === '' || routeId === null || routeId === undefined) {
        this.$router.push({path: '/RouteList'})
      }
      const param = this.$qs.stringify({ routeId: routeId })

      this.$axios.post('route/getRouteInfoByRouteId', param).then(response => {
        let routeData = response.data.routeInfo

        if (routeData === null) {
          this.$router.push({path: '/RouteList'})
        }
        new Promise((resolve) => {
          this.$axios.get('route/getAllStationData').then(res => {
            this.stationDataList = res.data.stationDataList
            // 开始Id
            let startStationId = routeData.routePassPointList[0].stationId
            // 终了Id
            let endStationId = routeData.routePassPointList[routeData.routePassPointList.length - 1].stationId
            for (const y of this.stationDataList) {
            // 找到开始点
              if (y.stationId === startStationId) {
                routeData.startStationAddress = y.address
                routeData.startStationAddressName = y.stationName
                routeData.startLng = y.stationLng
                routeData.startLat = y.stationLat
                routeData.startStaionName = y.stationName
              }
              // 找到终了点
              if (y.stationId === endStationId) {
                routeData.endStationAddress = y.address
                routeData.endStationAddressName = y.stationName
                routeData.endLng = y.stationLng
                routeData.endLat = y.stationLat
                routeData.endStaionName = y.stationName
              }
            }

            this.routeInfo = routeData
            routeInfo = this.routeInfo

            sessionStorage.setItem('clickRoute', JSON.stringify(routeData))

            // 停留所信息
            const stationDataList = this.stationDataList

            for (let i = 0; i < routeInfo.routePassPointList.length; i++) {
              const e = routeInfo.routePassPointList[i]
              for (let j = 0; j < stationDataList.length; j++) {
                const s = stationDataList[j]
                if (e.stationId === s.stationId) {
                // 当前页面需要的信息
                  this.routerInfo.push({
                    font: `${e.routeNo}`,
                    routeId: e.routeId,
                    stationId: s.stationId,
                    displayStationId: s.displayStationId,
                    stationName: s.stationName,
                    routeName: routeInfo.routeName,
                    address: s.address,
                    stationLat: s.stationLat,
                    stationLng: s.stationLng,
                    routeNo: e.routeNo,
                    note: s.note,
                    officeFlag: s.officeFlag
                  })
                  // 路线规划
                  this.pointList.push({
                    lng: s.stationLng,
                    lat: s.stationLat
                  })
                  // 传到便登录页面的信息
                  this.routerInfos.push({
                    routeId: e.routeId,
                    routeName: routeInfo.routeName,
                    stationId: s.stationId,
                    displayStationId: s.displayStationId,
                    stationLng: s.stationLng,
                    stationLat: s.stationLat,
                    routeNo: e.routeNo,
                    stationName: s.stationName
                  })
                }
              }
            }
            sessionStorage.setItem('pointList', JSON.stringify(this.pointList))
            sessionStorage.setItem('routerInfo', JSON.stringify(this.routerInfos))
            resolve()
          })
        }).then(() => {
          // 获取完数据再画图
          this.initMap()
        }).catch(error => {
          console.log(error)
        })
      })
    },
    // 初始化地图 获取图标和路线
    initMap () {
      new Promise((resolve) => {
        this.pointDataList = []
        for (let i of this.routerInfo) {
          let font
          if (i.routeNo === 0) font = 'S'
          else if (i.routeNo === this.routerInfo.length - 1) font = 'G'
          else if (i.routeNo !== 0 && i.routeNo !== this.routerInfo.length - 1) font = `${i.routeNo}`
          this.pointDataList.push({
            stationId: font,
            stationLng: i.stationLng,
            stationLat: i.stationLat,
            stationInfo: i,
            icon: font === 'S' ? STATION_ICON_FIRST : STATION_ICON
          })
        }
        resolve()
      }).then(() => {
        if(this.pointList.length>0){
            this.centerPoint.lat=this.pointList[0].lat
            this.centerPoint.lng=this.pointList[0].lag
        }        
        this.$refs.gMap.initializeGoogleMap().then(() => {
          this.$refs.gMap.plannRoute(this.pointList).then(res => {
            const { totalDistance, totalTime } = res[res.length - 1]
            this.routeInfo.routeTotalTime = totalTime
            this.routeInfo.routeDistance = totalDistance
            // 添加图标 并在 组件中监听事件
            if (this.pointDataList.length !== 0) {
              this.$refs.gMap.pointList = this.pointDataList
              // 添加图标
              let imgSize = {width: 45, height: 60}
              // 图标里面的字体样式
              let labelAnchor = {width: 25, height: 53}
              this.markList = this.$refs.gMap.addMark(imgSize, 'route-label-class', labelAnchor)
            }
          })
        })
      })
    },
    // 跳转到编辑路线 页面
    edit () {
      this.$router.push({name: 'EditRouterInfo'})
    },
    // 单击 获取当前路的详情
    detailed (item) {
      item.routeType = 0
      item.name = item.stationName
      this.$refs.saveWindowDiv.viewModel = item
      let center = { lat: item.stationLat, lng: item.stationLng }
      this.$refs.saveWindowDiv.centerPoint = center
      this.$refs.saveWindowDiv.markPosition = center
      this.$refs.saveWindowDiv.zoom = 14
      if (item.routeNo === 0) this.$refs.saveWindowDiv.mark = 'S'
      if (item.routeNo !== 0 && item.routeNo !== this.routerInfo.length - 1) this.$refs.saveWindowDiv.mark = `${item.routeNo}`
      if (item.routeNo === this.routerInfo.length - 1) this.$refs.saveWindowDiv.mark = 'G'
      this.$refs.saveWindowDiv.initiGoogleMap()
    },
    // 删除路线
    deleteRouter (id) {
      this.dialogOptionRouter.text = 'このルートを削除してもよろしいですか?'
      this.dialogOptionRouter.showNo = true
      this.dialogOptionRouter.confirmButtonText = 'はい'
      this.dialogOptionRouter.cancelButtonText = 'いいえ'
      this.showDialogRouter = true
      this.$refs.dialogRouter.confirm().then(() => {
        this.showDialogRouter = false
        const param = this.$qs.stringify({ routeId: id })
        this.$axios.post('route/deleteRouteData', param).then(result => {
          this.$router.push({path: '/RouteList'})
        }).catch(err => {
          console.log(err)
          this.showMessage(err.data.error_description)
        })
      }).catch(() => {
        this.showDialogRouter = false
      })
    },
    // message dialog
    showMessage (title, yesNoFlag, yesText, noText) {
      this.dialogOptionRouter.text = title
      this.dialogOptionRouter.showNo = yesNoFlag
      this.dialogOptionRouter.confirmButtonText = yesText
      this.dialogOptionRouter.cancelButtonText = noText
      this.showDialogRouter = true
      this.$refs.dialogRouter
        .confirm()
        .then(() => {
          this.showDialogRouter = false
        })
        .catch(() => {
          this.showDialogRouter = false
        })
    },
    // 便登录
    routeLogin () {
      this.$router.push({ name: 'RouteShiftLogin' })
    }
  }
}
</script>

<style lang='scss' scoped>
// @import '../../assets/css/C00.css';
.headerSty {
    position: absolute;
    font-size:0.6em;
    padding-left:20px;
    cursor:pointer;
}
.span {
    padding-left: 5px;
    font-weight: 600;
    vertical-align: middle
}
.body {
    display: flex;
    flex-direction: column;
    width: 98%;
    height: 100%;
    // border: 1px solid red;
    // margin: 1% 1% 2% 1%;
    margin: 1% 1% 0 1%;
    overflow: auto;
    // 主体
    .main {
        // height: 90%;
        // border: 1px solid blue;
        flex: 9;
        display: flex;
        flex-direction: row;
        // 左侧
        .main-left {
            display: flex;
            flex-direction: column;
            flex: 3.5;
            padding-right: 30px;
            // 左侧第一行
            .placeTitle {
                position: relative;
                height: 45px;
                background-color:black;
                .placeTitle-font {
                    position: absolute;
                    left: 10px;
                    color: black;
                    font-size: 1.5em;
                    font-weight: 600; // 字体粗度
                    top: 50%;
                    transform: translateY(-50%);
                }
            }
            // 左侧第二行
            .placeDistance {
                // position: relative;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                padding: 0 10px;
                height: 45px;
                background-color: #d7e6ea;
                // 子元素
                & > div {
                    font-size: 1.2em;
                    color: black;
                    font-weight: 400; // 字体粗度
                }
            }

            // 左侧第三行
            .placeInfo {
                flex: 1;
                overflow-y: auto;
                &-children {
                    background-color: #efefef;
                    height: 80px;
                    border-bottom: 1px solid #b9b9b8;
                    position: relative;
                    // 蓝色图标
                    .radioClass {
                        width: 40px;
                        height: 40px;
                        position: absolute;
                        background-color: #48a3be;
                        margin: 20px 0 0 15px;
                        border-radius: 40px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        // 覆盖权重
                        z-index: 2;
                        .tagClass {
                          color: white;
                            font-size: 1.5em;
                            font-weight: 100; // 字体粗度
                        }
                    }
                    .radioOffice{
                      background-color: #FFF;
                      border: 3px solid #48a3be;
                      .tagClass {
                        color: #48a3be;
                      }
                    }
                    // 正常竖线
                    .lineClass {
                        position: absolute;
                        left: 33px;
                        width: 4px;
                        height: 80px;
                        background-color: #48a3be;
                    }
                    // 图标第一个竖线
                    .lineClassFirst {
                        position: absolute;
                        left: 33px;
                        width: 4px;
                        height: 40px;
                        background-color: #48a3be;
                    }
                    // 图标末尾竖线
                    .lineClassEnd {
                        position: absolute;
                        left: 33px;
                        width: 4px;
                        height: 40px;
                        top: 40px;
                        background-color: #48a3be;
                    }
                    &-body {
                        // border: 1px solid red;
                        height: 100%;
                        padding-left: 70px;
                        display: flex;
                        flex-direction: column;
                        &:active {
                            background-color: #b2b2b2;
                        }
                        .front {
                            display: flex;
                            text-align: center;
                            & > span {
                                margin-top: 4px;
                                color: black;
                                font-size: 1.5em;
                                font-weight: 600; // 字体粗度
                            }
                        }
                        >.front:nth-child(2){
                          span{
                            margin-top: 2px;
                            text-align: left;
                          }
                        }
                    }
                }
            }
        }
        // 右侧
        .main-right {
            // border: 1px solid black;
            // width: 100px;
            flex: 6;
            #routerId {
                width: 100%;
                height: 100%;
            }
        }
    }
}
// 页脚
.body-foot {
    // border: 1px solid green;
    margin: 10px 0;
    flex: 1.5;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    & > button {
        width: 300px;
        height: 50px;
        border-radius: 15px;
        margin: 0 10px;
        // background-color: #686868;
        & > p {
            color: white;
            font-size: 1.5em;
            font-weight: 600; // 字体粗度
            transform: translateY(40%);
        }
    }
}
#stationDetailMapId {
    height: 100%;
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/router/views/RouteEvent.vue